// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"05c62f14","393":"f0caf125","669":"4bcd3668","803":"fd13f89b","851":"ed8012be","865":"817976a0","919":"a454d47e"}[chunkId] + ".chunk.js";
};